import { render, staticRenderFns } from "./ModalAddSportStage.vue?vue&type=template&id=19a3fecd&"
import script from "./ModalAddSportStage.vue?vue&type=script&lang=js&"
export * from "./ModalAddSportStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports